<template>
  <div class="client-domain-client-root datagrid-root">
    <div class="content-block">
      <div class="headline-container">
        <div class="headline-item"><h2>Domæne pengeinstitutter</h2></div>
      </div>
      <div><u @click="onBackClick" class="link">Pengeinstitutter</u> > Domæne pengeinstitutter</div>
    </div>

    <div class="content-block">
      <div class="back-button-container">
        <dx-button icon="back" text="Tilbage" @click="onBackClick"></dx-button>
      </div>
      <div class="grid-button-container">
        <div class="flex-align-right">
          <dx-button @click="onAddClick" icon="add" text="Tilføj" class="margin-right"></dx-button>
          <dx-button @click="clearFilterAndSorting" icon="clearfilter" hint="Fjern filter og sortering"></dx-button>
        </div>
      </div>
      <dx-data-grid
        ref="dataGrid"
        id="clientDomainClientDataGrid"
        :data-source="datasource"
        height="75vh"
        :focused-row-key="focusedRowKey"
        :column-auto-width="true"
        @row-removing="rowRemoving">

        <dx-selection mode="single"/>
        <dx-export :enabled="true" fileName="Domaene-pengeinstitutter" />
        <dx-filter-row :visible="true" />
        <dx-header-filter :visible="false" />
        <dx-grouping :auto-expand-all="false" />
        <dx-group-panel :visible="false" />
        <dx-state-storing :enabled="true" type="sessionStorage" storage-key="domainClient-list" />
        <dx-scrolling mode="virtual" />
        <dx-paging :page-size="50" />

        <dx-editing
          :allow-updating="false"
          :allow-deleting="true"
          :allow-adding="false"
          :confirm-delete="false"
          mode="form">
        </dx-editing>

        <dx-column
          data-field="clientRegistrationNumber"
          caption="Reg.nr."
          data-type="number"
          sort-order="asc"
          :selected-filter-operation="selectedOperation"
          :hiding-priority="8"
          width="130px">
        </dx-column>

        <dx-column
          data-field="clientName"
          caption="Navn"
          data-type="string"
          :hiding-priority="7">
        </dx-column>

        <dx-column
         type="buttons"
         :visible="false" />

        <dx-master-detail
          :enabled="false"
          template="detailTemplate" />

        <template #detailTemplate="{ data: row }">
          <div>
            <DetailView
              :row="row"
              @onDeleteClick="onDeleteClick" />
          </div>
        </template>
      </dx-data-grid>

      <AddForm
        :visible="showAddForm"
        :main-client-id="id"
        :clients="clientList.data"
        :existing-client-ids="existingClientIds"
        @save="onAddSave"
        @cancel="showAddForm = false" />
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import DetailView from '@/modules/masterData/clientDomainClients/components/detail-view.vue';
import AddForm from '@/modules/masterData/clientDomainClients/components/add-form.vue';
import BaseDataGrid from '@/components/common/base-datagrid.vue';
import useDatagrid from '@/modules/masterData/clientDomainClients/composables/datagrid.composable.js';

const selectedOperation = 'contains';

export default {
  name: 'ClientDomainClientsModule',
  extends: BaseDataGrid,
  components: {
    DetailView,
    AddForm,
  },
  props: {
    id: String,
  },
  setup(props) {
    const {
      datasource,
      domainClients,
      clientList,
      getDatasource,
      loadDomainClients,
      loadClients,
      addDomainClient,
    } = useDatagrid(props.id);

    getDatasource();
    loadDomainClients();
    loadClients();

    const showAddForm = ref(false);

    const existingClientIds = computed(() => domainClients.value.map((d) => String(d.clientId)));

    const router = useRouter();

    function onBackClick() {
      router.push({ name: 'MasterDataClients' });
    }

    function onAddClick() {
      showAddForm.value = true;
    }

    return {
      datasource,
      clientList,
      domainClients,
      existingClientIds,
      showAddForm,
      onAddClick,
      addDomainClient,
      router,
      onBackClick,
      selectedOperation,
    };
  },
  methods: {
    rowRemoving(e) {
      this.onRowRemoving(e, `Vil du fjerne dette domæne pengeinstitut?<br/><b>${e.data.clientName}</b>`, 'Fjern domæne pengeinstitut');
    },
    onAddSave(domainClientId) {
      this.addDomainClient(domainClientId).then((ok) => {
        if (ok) {
          this.showAddForm = false;
          this.refreshGrid();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.client-domain-client-root {
  .headline-container {
    display: flex;

    .headline-item {
      flex: 0 0 280px;

      h2 {
        margin-top: 0px;
      }
    }

    .subheadline-item {
      padding-top: 11px; font-size: 20px;
    }
  }

  .link:hover {
    cursor: pointer;
  }

  .back-button-container {
    height: 0px;
    position: relative;
    top: 30px;
    z-index: 100;
    padding-left: 20px;
  }

  .margin-right {
    margin-right: 5px;
  }
}
</style>
